export const ENTORNO = 'produccionMoviportHTTPS';

const localMoviport = {
    url: '//localhost',
    port: '3001',
    realTimeServerUrl: '//localhost',
    realTimeServerPort: '3001'
}

const localSolimeno = {
    url: '//localhost',
    port: '3001',
    realTimeServerUrl: '//localhost',
    realTimeServerPort: '3001'
}

const produccionMoviport = {
    url: 'http://52.27.239.196',
    port: '3000',
    realTimeServerUrl: 'http://52.27.239.196',
    realTimeServerPort: '3000'
}

const produccionMoviportHTTPS = {
    url: 'https://proveedores.moviportsa.com.ar',
    realTimeServerUrl: 'https://proveedores.moviportsa.com.ar'
}

const produccionSolimeno = {
    url: 'http://52.33.31.178',
    port: '3000',
    realTimeServerUrl: 'http://52.33.31.178',
    realTimeServerPort: '3000'
}

export function getRealTimeServerURL() {

    switch (ENTORNO) {
        case 'localMoviport':
            return `${localMoviport.realTimeServerUrl}:${localMoviport.realTimeServerPort}`;
            break;
        case 'localSolimeno':
            return `${localSolimeno.realTimeServerUrl}:${localSolimeno.realTimeServerPort}`;
            break;
        case 'produccionMoviport':
            return `${produccionMoviport.realTimeServerUrl}:${produccionMoviport.realTimeServerPort}`;
            break;
        case 'produccionMoviportHTTPS':
            return `${produccionMoviportHTTPS.realTimeServerUrl}`;
            break;
        case 'produccionSolimeno':
            return `${produccionSolimeno.realTimeServerUrl}:${produccionSolimeno.realTimeServerPort}`;
            break;
    }
}

export function getServerURL() {

    switch (ENTORNO) {
        case 'localMoviport':
            return `${localMoviport.url}:${localMoviport.port}/api`;
            break;
        case 'localSolimeno':
            return `${localSolimeno.url}:${localSolimeno.port}/api`;
            break;
        case 'produccionMoviport':
            return `${produccionMoviport.url}:${produccionMoviport.port}/api/`;
            break;
        case 'produccionMoviportHTTPS':
            return `${produccionMoviportHTTPS.url}/api/`;
            break;
        case 'produccionSolimeno':
            return `${produccionSolimeno.url}:${produccionSolimeno.port}/api/`;
            break;
    }
}